import { BaseService } from "./BaseService";

export class ReportService extends BaseService {
  constructor() {
    super("/admin/reports");
  }

  async getFechamentoSinteticoReport(period) {
    try {
      const response = await this.getClient().get(
        `${this.baseUrl}/fechamento-sintetico`,
        { params: { period } }
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getRelatorioAnalitico(period) {
    try {
      const response = await this.getClient().get(
        `${this.baseUrl}/relatorio-analitico`,
        { params: { period } }
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getRelatorioCancelamentos(period) {
    try {
      const response = await this.getClient().get(
        `${this.baseUrl}/relatorio-cancelamentos`,
        { params: { period } }
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getRelatorioEscalas(period) {
    try {
      const response = await this.getClient().get(`${this.baseUrl}/escalas`, {
        params: { period },
      });
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getFechamentoDepPessoal(period) {
    try {
      const response = await this.getClient().get(
        `${this.baseUrl}/fechamento-dep-pessoal`,
        { params: { period } }
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }
}
